<div class="location-popup">
  <div class="location-popup__heading">
    <div class="location-popup__heading--description">
      <b>{{ userName }}</b>
    </div>
  </div>
  <div class="location-popup__separator"></div>
  <div class="location-popup__body">
    <div class="location-popup__info">
      <div class="info-heading-text">
        {{ 'LocationPopup.Location' | translate }}
      </div>
      <div class="info-body-text">
        <b>{{ location }}</b>
      </div>
      <br />
      <div class="info-heading-text">
        {{ 'LocationPopup.Status' | translate }}
      </div>
      <div class="info-body-text">
        <div class="info-body-text__status">
          <img [src]="onCallStatusIconUrl[onCallStatus]" />
          <b>{{ 'OnCallStatus.' + onCallStatus | translate }}</b>
        </div>
      </div>
      <br />
      <div class="info-heading-text">
        {{ 'LocationPopup.Mobile' | translate }}
      </div>
      <div class="info-body-text">
        <b>{{ mobile }}</b>
      </div>
      <br />
      <div class="info-heading-text">
        {{ 'LocationPopup.Properties' | translate }}
      </div>
      <div class="info-body-text">
        <b>{{ properties }}</b>
      </div>
      <br />
      <div class="info-heading-text">
        {{ 'LocationPopup.Department' | translate }}
      </div>
      <div class="info-body-text">
        <b>{{ department }}</b>
      </div>
      <br />
      <div class="info-heading-text">
        {{ 'LocationPopup.CallOutCount' | translate }}
      </div>
      <div class="info-body-text">
        <b>{{ callOutCount }}</b>
      </div>
      <br />
    </div>
  </div>
  <div class="location-popup__call-out">
    @if (isCalledOut) {
      <div class="location-popup__called-out">
        <div><span class="dv-icons">check_circle </span></div>
        <div class="location-popup__called-out-text">
          <div>{{ 'LocationPopup.CalledOutText' | translate }}</div>
          <div
            class="location-popup__called-out-info"
            [dvTooltip]="
              'LocationPopup.CalledOutInfoText'
                | translate: { time: lastCallOutTime }
            ">
            <span class="dv-icons">info_filled</span>
          </div>
        </div>
      </div>
    }
    <dv-button
      class="location-popup__call-out--btn"
      color="secondary"
      [icon]="'ring_volume'"
      [disabled]="!hasOnCallEdit"
      (click)="callOut()"
      >{{ 'LocationPopup.CallOut' | translate | uppercase }}</dv-button
    >
  </div>
</div>
